import { gql } from '@apollo/client';
import { UserFields } from './fragments';

export const SIGN_IN_ADMIN_V2 = gql`
  mutation SignInAdminV2($input: SignInInput!) {
    signInAdminV2(input: $input) {
      id
      role
      accessToken
      refreshToken
      interviewerDetails {
        id
      }
    }
  }
`;

export const LOGIN_AS = gql`
  mutation LoginAs($input: LoginAsInput!) {
    loginAs(input: $input) {
      accessToken
      refreshToken
      id
      email
      role
      firstName
      lastName
    }
  }
`;

/** The mutation and its types are used at helpers/auth.ts helper */
export const REFRESH_TOKENS = gql`
  mutation RefreshTokens($input: RefreshTokensInput!) {
    refreshTokens(input: $input) {
      accessToken
      refreshToken
    }
  }
`;

export const SIGN_OUT = gql`
  mutation SignOut($input: SignOutInput!) {
    singOut(input: $input)
  }
`;

export const SIGN_UP_BASIC = gql`
  mutation SignUpBasic($input: SignUpV2Input!) {
    signUpBasic(input: $input) {
      userId
      tokens {
        accessToken
        refreshToken
      }
      user {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const SWITCH_TO_CREATOR = gql`
  mutation SwitchToCreator($input: SwitchToCreatorInput!) {
    switchToCreator(input: $input) {
      ...UserFields
    }
  }
  ${UserFields}
`;
